/**
 * Platform Detection Utilities
 *
 * Helps determine the runtime environment:
 * - Web browser
 * - PWA (installed)
 * - Capacitor (native wrapper)
 *
 * Use these to conditionally handle platform-specific logic
 */

export const isCapacitor = (): boolean => {
  return !!(window as any).Capacitor;
};

export const isPWA = (): boolean => {
  // return true;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (window.navigator as any).standalone === true
  );
};

export const isWeb = (): boolean => {
  return !isCapacitor() && !isPWA();
};

export const getPlatform = (): "web" | "pwa" | "capacitor" => {
  if (isCapacitor()) return "capacitor";
  if (isPWA()) return "pwa";
  return "web";
};
